import type { OneNoteFeedPanelSource } from "../OneNoteFeedPanelSource";
import { action } from "satcheljs";

/**
 * Opens OneNote Feed Panel
 */
export interface OpenOneNoteFeedPanelActionMessage {
    source: OneNoteFeedPanelSource;
}
export const openOneNoteFeedPanel: (source: OneNoteFeedPanelSource) => OpenOneNoteFeedPanelActionMessage = action("openOneNoteFeedPanel", (source: OneNoteFeedPanelSource): OpenOneNoteFeedPanelActionMessage => ({
    source,
}));
